import { createEnvelopeSource } from './create-envelope-source';

/**
 * All-time app downloads over the standardized envelope
 * (`GET /analytics/downloads/total`): one lifetime figure for both stores.
 *
 * The endpoint validates the requested window and echoes it back on `range`,
 * but never queries it: this KPI serves the same total whatever period the page
 * asks for. A card reading it must say so, or the number reads as a period
 * figure that mysteriously ignores the picker.
 *
 * Separate from `app-downloads`, which sums two per-platform endpoints over the
 * selected period and carries a per-store freshness warning. This one has no
 * platform axis to split and no compare arm to draw a delta from.
 */
export const appDownloadsTotalSource = createEnvelopeSource({
    label: 'All-time downloads',
    endpoint: 'analytics/downloads/total',
    metrics: [
        {
            id: 'appDownloadsTotal',
            label: 'All-time downloads',
            type: 'scalar',
        },
    ],
    forms: ['number'],
    regionGrain: 'brand',
});
